

import { onUnmounted, ref } from '@vue/composition-api'
import {FilterServices} from './services'

export default function filter(type) {


  const ownersOptions = ref([])
  const contractsOptions = ref([])
  const categoriesOptions = ref([])
  const typesOptions = ref([])



  FilterServices.getFilterOptionsBy(type)
  
    .then(response => {
      const { 

      categories, groups, contracts, owners, managers, roles, types } = response.data.data
      console.log('tttttttttttttttttt',types)
      ownersOptions.value = owners
      contractsOptions.value = contracts
      categoriesOptions.value = categories
      typesOptions.value = types




    })


  return {
    ownersOptions,
    typesOptions,
    categoriesOptions,
    contractsOptions,



  }

}
